import React from 'react'
import {
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  DialogActions,
  Button
} from '@material-ui/core'
import { IInitiativesSelectorDialogViewProps } from './Interfaces'
import ArrowIcon from '@material-ui/icons/ArrowRight'
import Provider from './Provider'
import InitiativesSelectorDialog from './Service'

const InitiativesSelectorDialogView: React.FC<IInitiativesSelectorDialogViewProps> = ({ state, onInitiativeClick }) => {
  return (
    <React.Fragment>
      <Dialog
        open={state.isDialogOpenState === 'OPEN'}
        fullWidth
        maxWidth="sm"
        aria-labelledby="initiatives-selector-dialog"
      >
        <DialogTitle id="initiatives-selector-dialog">Now it’s time to answer the initiative questions!</DialogTitle>
        <List dense>
          {state.initiativesOptions.map((item, index) => (
            <ListItem key={index} button onClick={() => onInitiativeClick(item)}>
              <ListItemText primary={item.initiative_title} />
              <ListItemSecondaryAction>
                <ArrowIcon />
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
        <DialogActions>
          <Button
            id="initiatives-selector-dialog-remind-me-later-button"
            onClick={() => InitiativesSelectorDialog.setIsDialogOpen('CLOSED_BY_USER')}
            color="primary"
          >
            Remind me later
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}

export default () => (
  <Provider>
    {(viewProps: IInitiativesSelectorDialogViewProps) => <InitiativesSelectorDialogView {...viewProps} />}
  </Provider>
)
